const safeDuration = (value) => Math.max(0, Number(value) || 0)

export const buildPreviewTimeline = (reel) => {
  if (!reel) return []
  const items = reel.source === 'upload'
    ? [{ id: 'upload', durationSec: (reel.uploadedVideo || {}).durationSec }]
    : (reel.scenes || [])
  let cursor = 0
  return items.map((item, index) => {
    const duration = safeDuration(item.durationSec)
    const entry = { id: item.id || `scene-${index}`, index, start: cursor, end: cursor + duration, duration }
    cursor = entry.end
    return entry
  })
}

export const previewPositionAt = (timeline, seconds) => {
  if (!timeline || !timeline.length) return { index: 0, globalTime: 0, localTime: 0 }
  const total = timeline[timeline.length - 1].end
  const globalTime = Math.min(Math.max(0, Number(seconds) || 0), total)
  const index = globalTime >= total
    ? timeline.length - 1
    : Math.max(0, timeline.findIndex((entry) => globalTime < entry.end))
  return {
    index,
    globalTime,
    localTime: Math.min(timeline[index].duration, Math.max(0, globalTime - timeline[index].start)),
  }
}
